angular.module('tgaAdmin')
  .controller('GameAccessController', [
    '$scope', '$state', '$location', '$timeout', 'userService', 'flashService',
    'modalService', 'game',
    function (
      $scope, $state, $location, $timeout, userService, flashService,
      modalService, game,
    ) {
      $scope.showBack = false;

      $scope.data = {
        alerts: [],
        game_id: $state.params.game_id || null,
        users: [],
        addAllEditorsClicked: true,
        deleteAllEditorsClicked: false,
        editorUsers: ['editor', 'creator_admin'],
        viewerUsers: ['user', 'viewer_admin'],
      };

      $scope.viewmodel = {
        game,
        userEditor: null,
        userViewer: null,
        userAccessEditors: [],
        priorAccessEditors: [],
        userAccessViewers: [],
        priorAccessViewers: [],
      };

      $scope.initialize = function () {
        $scope.title = `<span class="text-muted">Permissions /</span> ${$scope.viewmodel.game.name}`;

        $scope.loading = true;

        userService.getUsersList().then((users) => {
          $scope.data.users = users;

          $scope.loading = false;
        }).catch((error) => {
          $scope.actions.processError(error);
        });

        userService.getGameAccessUsers($scope.data.game_id).then((users) => {
          $scope.viewmodel.userAccessEditors = users.filter((u) => $scope.data.editorUsers.includes(u.user_type));

          $scope.viewmodel.userAccessViewers = users.filter((u) => $scope.data.viewerUsers.includes(u.user_type));

          $scope.loading = false;
        }).catch((error) => {
          $scope.actions.processError(error);
        });
      };

      $scope.actions = {
        submit(form) {
          form.submitted = true;
          $scope.data.alerts = [];

          if (form.$invalid) {
            return;
          }

          form.processing = true;

          const userData = {
            game_id: $scope.data.game_id,
            user_id: null,
            user_type: null,
          };

          if (form.$name === 'editorForm') {
            userData.user_type = form.user.$modelValue.user_type;
            userData.user_id = $scope.viewmodel.userEditor.id;
          }

          if (form.$name === 'viewerForm') {
            userData.user_type = form.user.$modelValue.user_type;
            userData.user_id = $scope.viewmodel.userViewer.id;
          }

          userService.addUserGameAccess(userData).then(
            () => {
              $scope.actions.createAlert('<span class="fa fa-check"></span> User access updated.', 'success');
              $scope.viewmodel.userEditor = null;
              $scope.viewmodel.userViewer = null;
              form.submitted = false;
              form.processing = false;
              $scope.initialize();
            },
            (error) => {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
              form.processing = false;
            },
          );
        },
        toggleAll(user_type, value) {
          $scope.togglingAll = true;

          const data = {
            game_id: $scope.viewmodel.game.game_id,
            user_type,
            value,
            all_users: true,
          };

          if (user_type === 'editor') {
            // If turning on all access, save prior access list so they can toggle back to original state
            if (value) {
              $scope.viewmodel.priorAccessEditors = angular.copy($scope.viewmodel.userAccessEditors);
            } else if ($scope.viewmodel.priorAccessEditors.length) {
              data.users = $scope.viewmodel.priorAccessEditors;
            }

            $scope.viewmodel.userAccessEditors = [];
          } else {
            if (value) {
              $scope.viewmodel.priorAccessViewers = angular.copy($scope.viewmodel.userAccessViewers);
            } else if ($scope.viewmodel.priorAccessViewers.length) {
              data.users = $scope.viewmodel.priorAccessViewers;
            }

            $scope.viewmodel.userAccessViewers = [];
          }

          userService.addUserGameAccess(data).then(
            () => {
              $scope.actions.createAlert('<span class="fa fa-check"></span> User access updated.', 'success');
              $scope.initialize();
              $scope.togglingAll = false;
            },
            (error) => {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
              $scope.togglingAll = false;
            },
          );
        },
        createAlert(msg, type) {
          $scope.data.alerts = [];
          $scope.data.alerts.push({
            msg,
            type,
          });

          if ($scope.timer) {
            $timeout.cancel($scope.timer);
          }

          $scope.timer = $timeout(() => {
            $scope.data.alerts.splice($scope.data.alerts.length - 1, 1);
          }, 5000);
        },
        removeUserAccess(user) {
          modalService.showModal({
            title: 'Remove Game Access',
            message: 'Are you sure you want remove this user\'s access?',
            closeButton: 'No',
            actionButton: 'Yes',
          }, {
            backdrop: true,
            keyboard: true,
            animation: false,
          }).then(() => {
            user.processing = true;
            userService.deleteUserAccess(user.game_access_id).then(
              () => {
                $scope.actions.createAlert('<span class="fa fa-check"></span> User access updated.', 'success');
                $scope.initialize();
              },
              (error) => {
                $scope.actions.createAlert(
                  `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                  'danger',
                );
                user.processing = false;
              },
            );
          }, () => { });
        },
        notAdded(user) {
          let addedUsers = [];

          if ($scope.data.editorUsers.includes(user.user_type)) {
            addedUsers = $scope.viewmodel.userAccessEditors;
          } else {
            addedUsers = $scope.viewmodel.userAccessViewers;
          }

          const added = addedUsers.filter((u) => u.user_id === user.id);

          return added.length === 0;
        },
        userIsEditor(user) {
          return $scope.data.editorUsers.includes(user.user_type);
        },
        userIsViewer(user) {
          return $scope.data.viewerUsers.includes(user.user_type);
        },
        processError(error) {
          if (!error.errors) {
            $scope.actions.createAlert(`<span class="fa fa-exclamation-triangle"></span> ${error}`, 'danger');
            return;
          }

          if (error.errors.length) {
            error.errors.forEach((e) => {
              $scope.actions.createAlert(`<span class="fa fa-exclamation-triangle"></span> ${e.message}`, 'danger');
            });
          }
        },
      };

      $scope.initialize();
    },
  ]);
